import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Tools",
  "description": "Learn how to use your favorite tools in a monorepo."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo works with all of your favorite tooling. Below, you'll find guides for the most common tools being used with Turborepo."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo works with ", _jsx(_components.strong, {
        children: "all of your favorite tooling"
      }), ". Below, you'll find guides for the most common tools being used with Turborepo."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Biome",
        href: "/docs/guides/tools/biome"
      }), _jsx(Card, {
        title: "Docker",
        href: "/docs/guides/tools/docker"
      }), _jsx(Card, {
        title: "ESLint",
        href: "/docs/guides/tools/eslint"
      }), _jsx(Card, {
        title: "Jest",
        href: "/docs/guides/tools/jest"
      }), _jsx(Card, {
        title: "Prisma",
        href: "/docs/guides/tools/prisma"
      }), _jsx(Card, {
        title: "shadcn/ui",
        href: "/docs/guides/tools/shadcn-ui"
      }), _jsx(Card, {
        title: "Storybook",
        href: "/docs/guides/tools/storybook"
      }), _jsx(Card, {
        title: "TypeScript",
        href: "/docs/guides/tools/typescript"
      }), _jsx(Card, {
        title: "Vitest",
        href: "/docs/guides/tools/vitest"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
